import { ThemeTokens } from './themes';

export function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  if (typeof hex !== 'string') return null;
  let h = hex.trim().replace(/^#/, '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
}

export function deriveBrandTokens(hex: string): ThemeTokens {
  const rgb = hexToRgb(hex);
  if (!rgb) return {};
  const { r, g, b } = rgb;
  const rgba = (a: number) => `rgba(${r}, ${g}, ${b}, ${a})`;
  return {
    '--color-primary': hex,
    '--color-primary-light': rgba(0.1),
    '--color-primary-medium': rgba(0.3),
    '--color-primary-strong': rgba(0.8),
    '--shadow-primary-sm': `0 2px 10px ${rgba(0.15)}`,
    '--shadow-primary-md': `0 6px 20px ${rgba(0.2)}`,
    '--shadow-primary-lg': `0 14px 40px ${rgba(0.25)}`,
  };
}
